<template lang="pug">
Suspense
  .native-app-orders-screen(v-bind="$attrs")
    Tabs(v-model="activeTab" :tabs="['Order History', 'Track Orders']" theme="app")
    OrderHistory(v-show="activeTab === 'Order History'")
    TrackOrders(v-show="activeTab === 'Track Orders'")
</template>

<script setup lang="ts">
import { ref } from 'vue'
import OrderHistory from './components/native-app-order-history.vue'
import TrackOrders from './components/native-app-track-orders.vue'

const activeTab = ref<'Order History' | 'Track Orders'>('Order History')
</script>

<style scoped lang="scss">
.native-app-orders-screen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
